import { render, staticRenderFns } from "./psc-box3.vue?vue&type=template&id=5696af96&scoped=true&"
import script from "./psc-box3.vue?vue&type=script&lang=js&"
export * from "./psc-box3.vue?vue&type=script&lang=js&"
import style0 from "./psc-box3.vue?vue&type=style&index=0&id=5696af96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5696af96",
  null
  
)

export default component.exports